export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column-reverse' as 'column-reverse',
  },
};
